import { ProvisionApi } from '@Apis';
import { useQuery } from '@tanstack/react-query';

export const getProvisionedServicesQueryKey = (orgId: string) => [
  'getProvisionedServices',
  orgId,
];

export const useProvisionedServicesQuery = (orgId: string) => {
  const query = useQuery({
    queryKey: getProvisionedServicesQueryKey(orgId),
    queryFn: async () => {
      const response = await ProvisionApi.getProvisionedServices(orgId);
      return response.data;
    },
    enabled: !!orgId,
    staleTime: 60 * 1000,
  });

  return query;
};
